import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { useRetrieveDivision, useRetrieveDivisionsBySeasonId, useUpdateDivision, } from "../api/DivisionApiProvider";
import { useRetrieveUserLeaguePermissions } from "../api/PermissionApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { DivisionForm } from "./DivisionForm";
export const UpdateDivision = () => {
    const { leagueId, seasonId, id } = useNumericParams();
    const navigate = useNavigate();
    const { data: permissions, isLoading: permissionsLoading, error: permissionsError, } = useRetrieveUserLeaguePermissions({ leagueId });
    const { canModify = false } = permissions || {};
    const { data: division, isLoading, error } = useRetrieveDivision({ id });
    const { data: divisions = [], isLoading: divisionsLoading } = useRetrieveDivisionsBySeasonId({
        seasonId: division?.season,
        enabled: !!division?.season && canModify,
    });
    const mutation = useUpdateDivision({
        onMutate: () => { },
        onSuccess: (data) => {
            const updated = data.data;
            navigate(`/leagues/${leagueId}/seasons/${updated.season}`);
        },
        onError: () => { },
    });
    if (!id || !leagueId || !seasonId) {
        return (_jsx(ErrorView, { error: new Error("Missing division, league, or season id") }));
    }
    if (permissionsLoading ||
        isLoading ||
        mutation.isLoading ||
        divisionsLoading) {
        return _jsx(Loading, {});
    }
    if (permissionsError) {
        return _jsx(ErrorView, { error: permissionsError });
    }
    if (!canModify) {
        return _jsx(NotFound, {});
    }
    if (error || !division) {
        return _jsx(ErrorView, { error: error || new Error("Failed to load division") });
    }
    return (_jsxs(_Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update division. Please try again.", onClose: () => { } }), _jsx(DivisionForm, { onSubmit: (data) => mutation.mutate(data), seasonId: division.season, existingDivisions: divisions, division: division })] }));
};
